import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  GetAnalyticsDto,
  MostActiveUsersResponse,
} from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getMostActiveUsers = async ({
  from,
  to,
  organisationId,
  limit = 10,
  offset = 0,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<MostActiveUsersResponse>(
    `/analytics/most-active-users`,
    {
      params: { from, to, organisationId, limit, offset },
    },
  );

  return response.data;
};

export function useGetMostActiveUsers(
  { from, to, organisationId, limit, offset }: GetAnalyticsDto,
  queryOptions?: Partial<UseQueryOptions<MostActiveUsersResponse, HttpError>>,
) {
  return useQuery({
    queryKey: [
      "analytics",
      "most-active-users",
      from,
      to,
      organisationId,
      limit,
      offset,
    ],
    queryFn: () =>
      getMostActiveUsers({ from, to, organisationId, limit, offset }),
    ...queryOptions,
  });
}
